import { Component } from '@angular/core';
import { IzzyOrganizationActionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Organization Actions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyorganizationaction-form',
    templateUrl: './izzyorganizationaction.form.component.html'
})
export class IzzyOrganizationActionFormComponent extends BaseFormComponent {
    public record!: IzzyOrganizationActionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'organizationMapping', sectionName: 'Organization Mapping', isExpanded: true },
            { sectionKey: 'actionSettings', sectionName: 'Action Settings', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

